import { useCallback, useEffect, useState } from "react";
import { ContractService } from "../../../../core/services/ContractService"
import { BasicPage } from "../../../theme/Component/BasicPage"
import { Singleton } from '../../../../core/services/Singleton';
import { InputDate } from "../../../theme/Input/InputDate";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { AdquisitionArticle } from "../../adquisition-setting/AdquisitionArticle";
import { AdquisitionItemBudgetID } from "../../AdquisitionItemBudgetID";
import { OfferEmployee } from "../../FlowHiring/OfferEmployee/OfferEmployee";
import { ContractArticles } from "./ContractArticles";
import { AccountEditor } from "../../../editor/AccountEditor";
import { AdquisitionItemSelector } from "./ublinvoice/AdquisitionItemEditor/AdqusitionItemSelector";
import { toast } from "react-toastify";
import { SelectModalityNewSer } from "../../select/SelectModalityNewSer";
import { ContractTypeEditor } from "../../select/ContractTypeEditor";
import { _BusinessProcess, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { AdquisitionContractRP } from "./adquisitionContractRP/AdquisitionContractRP";
import usePaginator from "../../../theme/Component/usePaginator";
import { AdquisitionContracModify } from "../AdquisitionContracModify/AdquisitionContracModify";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { ExportXLSL } from "../../../theme/Component/ExportXLSX";
import { DropDown } from "../../../theme/Component/DropDown";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { ContractProject } from "./ContractProject";
import AutoChart from "../../../../core/graph/AutoChart";
import { ResumeContract } from "./ResumeContract";
import { InfoSecop } from "./InfoSecop";
import { ContractFiles } from "../ContractFiles";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { EditorExpedientDocumentFile } from "../../../DocumentManagement/Management/DocumentFileManager/EditorExpedientDocumentFile";
import useProjectValidations from "../../../theme/Component/hooks/useProjectValidations";



export const RegisterContract = () => {

    const single = _single;
    const contracService = new ContractService();
    const _bProcess = useDataBean(_BusinessProcess)
    const paginador = usePaginator();

    const [bean, setBean] = useState<any>({});
    const [filter, setFilter] = useState<any>({});
    const [beanItem, setBeanItem] = useState<any>({});
    const [IdAcoount, setIdAcoount] = useState<number>(null)
    const [FechaIni, setIFechaIni] = useState<number>(null)
    const [FechaOut, setIFechaOut] = useState<number>(null)
    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [missingFields, setMissingFields] = useState<string[]>([]);
    const [modalModify, setModalModify] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalRP, setModalRP] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalConf, setModalConf] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalRubro, setModalRubro] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-md' });
    const [modalArt, setModalArt] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalPer, setModalPer] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalRelacion, setModalRelacion] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalExpe, setModalExpe] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });

    useEffect(() => {
        if (!modal.view) setBeanItem({});
    }, [modal.view]);

    const [lista, setLista] = useState<any>([]);
    const [listaAll, setListaAll] = useState<any>([]);
    const modalXLS = useModal("Detallado", MODAL_SM);
    const modalProject = useModal("Proyecto", MODAL_md);
    const modalGraph = useModal("Grafica", MODAL_XL);
    const modalResumenContrato = useModal("Resumen", MODAL_LG);
    const modalSecop = useModal("Información SECOP", MODAL_LG);
    const modalRequest = useModal("", MODAL_md);


    useEffect(() => {
        initBean();
        return () => {
            setBean({});
        }
    }, [IdAcoount, FechaIni, FechaOut])


    const initBean = () => {
        setBean({
            ...bean,
            IDEmployee: single.getAccountID(),
            isLote: false,
            SeleccionDate: single.getCurrenDate(),
            IDAdquisitionContract: null,
            IDSupplier: null,
            ContractValue: null,
            Code: "",
            IDAdquisitionItem: null,
        });
    }

    const getSupplierCatalogPorPropiedad = useCallback(() => {
        contracService.getSupplierCatalogPorPropiedades({ IDAccount: bean.IDAccount }, null).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    let temp = resp.DataBeanProperties.ObjectValue;
                    console.log(temp);
                    if (temp.length > 0) {
                        setBean({ ...bean, "IDSupplier": temp[0].DataBeanProperties.IDSupplier });
                    } else {
                        if (bean.IDAdquisitionContract > 0) {
                            toast.warning("El usuario no esta registrado como proveedor");
                            setModal({ ...modal, "view": false });
                        }
                        // contracService.updateSupplier({
                        //     DataBeanProperties:{
                        //         IDAccount:bean.IDAccount,
                        //         IDRepresentative:bean.IDAccount,
                        //         NameLegalRep:bean.EntityName,
                        //         ContactName:bean.EntityName,
                        //         Name:bean.EntityName,
                        //         eMail:"",
                        //         Tel:"",
                        //         Address:"",
                        //         DocType:"24",
                        //         State:1
                        //     },
                        //     DataBeanName:"com.orange.finance.supplier.bean.Supplier"
                        // }).subscribe(
                        //     (resp:any)=>{
                        //         let temp = resp.DataBeanProperties.ObjectValue;
                        //         let sup = temp.DataBeanProperties;
                        //         if(sup.IDSupplier)
                        //         {
                        //             console.log(sup);
                        //             setBean({...bean,"IDSupplier":sup.IDSupplier});
                        //         }
                        //     }
                        // )
                    }

                }
            }
        )
    }, [bean.IDAccount])

    const crearContrato = () => {

        single.spinner(true);


        contracService.registerAdquisitionContractByItems(_single.getAccountID(), bean).subscribe(
            (resp: any) => {

                if (resp.DataBeanProperties.ErrorMessage) {
                    toast.error(resp.DataBeanProperties.ErrorMessage);
                }
                else if (resp.DataBeanProperties.ObjectValue) {
                    let tmp = resp.DataBeanProperties.ObjectValue.DataBeanProperties;
                    if (tmp.IDAdquisitionContract) {
                        bean.IDAdquisitionContract = tmp.IDAdquisitionContract;
                    }
                    actualizarContrato();
                    setModal({ ...modal, "view": false });
                }
                single.spinner(false);
            }
        )
    }
    const actualizarContrato = () => {
        single.spinner(true);
        console.log(bean);

        contracService.updateAdquisitionContract(bean).subscribe(
            (resp: any) => {

                if (resp.DataBeanProperties.ErrorMessage) {
                    toast.error(resp.DataBeanProperties.ErrorMessage);
                }
                else if (resp.DataBeanProperties.ObjectValue) {
                    getAdquisitionContractRender();
                    setModal({ ...modal, "view": false });
                }
                single.spinner(false);
            }
        )
    }
    const elimiarItem = () => {
        single.spinner(true);
        let beandelete = {
            IDAdquisitionContract: bean.IDAdquisitionContract,
            State: 2,
            IDEmployeeDelete: single.getAccountID(),
            LastUpdate: single.getCurrenDate()
        }
        contracService.updateAdquisitionContract(beandelete).subscribe(
            (resp: any) => {

                if (resp.DataBeanProperties.ObjectValue) {

                    getAdquisitionContractRender();

                }
                single.spinner(false);
            }
        )
    }

    useEffect(() => {
        getAdquisitionContractRender();
    }, [paginador.page])

    const getAdquisitionContractRender = () => {
        single.spinner(true);


        let x: any = IdAcoount ? {
            IDAccount: IdAcoount,
            State: 1,
        } : {
            State: 1
        };

        if (filter.IDAdquisitionItem > 0) {
            x.IDAdquisitionItem = filter.IDAdquisitionItem;
        }
        if (filter.Description?.length > 3) {
            x.Description = filter.Description;
        }
        if (filter.IDContractType > 0) {
            x.IDContractType = filter.IDContractType;
        }
        if (filter.ProjectName != '') {
            x.ProjectName = filter.ProjectName;
        }
        if (filter.InternalCode != '') {
            x.InternalCode = filter.InternalCode;
        }
        contracService.getAdquisitionContractRenderReport(paginador.page, 15, x, FechaIni, FechaOut, year).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    const response = resp.DataBeanProperties.ObjectValue.DataBeanProperties;

                    paginador.setPages(response.NumberOfPages);
                    setLista(response.List);
                }
                setModalConf({ ...modalConf, "view": false });
                single.spinner(false);
            }
        );
    }
    const getAdquisitionContractRenderALL = () => {
        single.spinner(true);

        let x: any = IdAcoount ? {
            IDAccount: IdAcoount,
            State: 1,
        } : {
            State: 1
        };

        if (filter.IDAdquisitionItem > 0) {
            x.IDAdquisitionItem = filter.IDAdquisitionItem;
        }
        if (filter.Description?.length > 3) {
            x.Description = filter.Description;
        }
        if (filter.IDContractType > 0) {
            x.IDContractType = filter.IDContractType;
        }

        contracService.getAdquisitionContractRenderReport(1, 30000, x, FechaIni, FechaOut, year).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    const response = resp.DataBeanProperties.ObjectValue.DataBeanProperties;
                    let temp = response.List;
                    temp.forEach(element => {
                        element.DataBeanProperties.ContractAmount = parseInt(element.DataBeanProperties.ContractAmount ?? 0);
                    });
                    setListaAll(temp);


                }

                single.spinner(false);
            }
        );
    }

    const clearFilter = () => {
        setIdAcoount(null)
        setIFechaIni(null)
        setIFechaOut(null)
        setFilter({ ...filter, "ProjectName": '', "Description": '', "IDAdquisitionItem": undefined, InternalCode: '' })
    }

    const validateData = () => {
        bean.SeleccionDate = bean.AdquisitionContractDate;
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            if (bean.IDAdquisitionContract > 0) {
                actualizarContrato();
            }
            else {
                crearContrato();
            }
        }
    }

    const create = () => {
        setBean({
            IDEmployee: single.getAccountID(),
            isLote: false,
            SeleccionDate: single.getCurrenDate(),
            IDAdquisitionContract: null,
            IDSupplier: null,
            ContractValue: null,
            Code: "",
            IDAdquisitionItem: null,
            State: 1
        });
        setModal({ ...modal, "view": true });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: () => { create() } }
    ]



    const head = [
        { title: 'ID', property: 'IDAdquisitionContract', visible: false, mask: MASK_NUMBER },
        { title: 'ID PAA', property: 'IDAdquisitionItem', visible: true, mask: MASK_NUMBER },
        { title: 'Proyecto', property: 'ProjectName', visible: true },
        { title: 'Tipo Contrato', property: 'ContractTypeName', visible: false },
        { title: 'Código contrato', property: 'InternalCode', visible: true },
        { title: 'Valor Contrato', property: 'ContractAmount', visible: true, mask: MASK_MONEY },
        { title: 'Nit', property: 'Nit', visible: true, mask: MASK_NUMBER },
        { title: 'Proveedor', property: 'Name1', visible: true },
        { title: 'Fecha Contrato', property: 'SeleccionDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Final', property: 'FinalContractDate', visible: true, mask: MASK_DATE },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Modalidad', property: 'NameModality', visible: false },
        { title: 'Estado', property: 'PreparationStateName', visible: false },
        { title: 'Radicado', property: 'Code', visible: false },


    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Expediente del Contrato', icono: 'ri-folder-5-line', visible: true, evento: () => { setModalExpe({ ...modalExpe, "view": true, "name": "Documenos Contrato" }) } }, ,
            { titulo: 'Información Secop', icono: 'ri-list-check-2', visible: true, evento: () => { modalSecop.open() } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-eraser-fill', visible: single.canDelete(), evento: () => { setModalConf({ ...modalConf, "view": true }) } },
            { titulo: 'Personal', icono: 'ri-group-line', visible: true, evento: () => { setModalPer({ ...modalPer, "view": true, "name": "Personal a cargo" }) } },
            { titulo: 'Rubros', icono: 'ri-currency-line', visible: true, evento: () => { setModalRubro({ ...modalRubro, "view": true, "name": "Rubro Presupuestal" }) } },
            { titulo: 'Articulos Necesidad', icono: 'ri-list-unordered', visible: true, evento: () => { setModalArt({ ...modalArt, "view": true, "name": "Articulos de la necesidad" }) } },
            { titulo: 'Articulos Contrato', icono: 'ri-list-ordered text-success', visible: true, evento: () => { setModalRelacion({ ...modalRelacion, "view": true, "name": "Articulos del contrato" }) } },
            { titulo: 'Proyectos', icono: ' ri-git-branch-fill', visible: true, evento: () => { modalProject.open() } },
            { titulo: 'Asociar RP', icono: 'ri-file-list-line', visible: true, evento: () => { setModalRP({ ...modalRP, "view": true, "name": "RP Asociados" }) } },
            { titulo: 'Modificaciones Contractuales', icono: 'ri-list-check-2', visible: true, evento: () => { setModalModify({ ...modalModify, "view": true, "name": "Modificaciones Contractuales" }) } },
            { titulo: 'Ejecucion Contrato', icono: 'ri-list-check-2', visible: true, evento: () => { modalResumenContrato.open() } },
            {
                titulo: 'Solicitud liquidacion de Contrato', icono: 'ri-money-dollar-box-line', visible: bean.PreparationState == 12, evento: () => {
                    setSelectedAction("GCLC");
                    modalRequest.open(`Solicitar liquidacion de contato  ${bean.InternalCode ?? bean.IDAdquisitionContract}`);
                }
            },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [selectedAction, setSelectedAction] = useState<string>("");
    const [isValid, setIsValid] = useState<boolean>(false);
    const [obs, setObs] = useState<string>("");

    const handleModalSubmit = () => {
        if (!obs || obs.length < 15) {
            toast.error("La observación es obligatoria y debe tener al menos 15 caracteres.");
            setIsValid(true);
            return;
        }

        setIsValid(false);

        const initProps = {
            FromDate: _single.getCurrenDate(),
            User: _single.getAccountID(),
            IDAdquisitionContract: bean.IDAdquisitionContract,
            ContractValue: bean.ContractValue,
            ContractSeleccionDate: bean.SeleccionDate,
            IDAccountSupplier: bean.IDAccountSupplier,
            IDAdquisitionItem: bean.IDAdquisitionItem,
            InternalCode: bean.InternalCode,
            IDHiringModality: bean.IDHiringModality,
            Nit: bean.Nit,
        };

        let processType = "";
        switch (selectedAction) {
            case "STARTSOLOP":
                processType = "STARTSOLOP";
                break;
            case "GCLC":
                processType = "GCLC";
                break;
            default:
                return;
        }

        _bProcess.instance.requestBusinessProcess(
            _single.getAccountID(),
            obs,
            processType,
            "IDAdquisitionContract",
            bean.IDAdquisitionContract,
            JSON.stringify(initProps),
            ""
        )
            .then((resp) => {
                toast.success(`Se ha Generado el Proceso ${resp.AlphaCode}`, { autoClose: false });
                modalRequest.close();
            })
            .catch(err => console.log(err));
    };

    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },
        { id: 2, name: 'Reporte Grafico', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id === 1) {
                            modalXLS.open();
                            getAdquisitionContractRenderALL();
                        }
                        else if (e.id === 2) {
                            modalGraph.open();
                            getAdquisitionContractRenderALL();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }

    const validateForm = () => {
        const requiredFields = [
            "AdquisitionContractDate", "IDAccount",
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length
    };

    const projectValidation = useProjectValidations(beanItem.IDProject);

    return (
        <>
            <BasicPage titulo="Registro Contratos">
                <div className="row">
                    <div className="col-md-2">
                        <YearSelector onChange={setYear} />
                    </div>
                    <div className="col-md-3">
                        <AccountEditor label="Beneficiario" idAccount={IdAcoount} onChange={(e) => { setIdAcoount(e.IDAccount) }} />
                    </div>
                    <div className="col-md-3">
                        <InputDate notDate={true} name="desde" label="Inicio" value={FechaIni} setDate={(e: any) => { setIFechaIni(e) }} />
                    </div>
                    <div className="col-md-3">
                        <InputDate notDate={true} name="hasta" label="Final" value={FechaOut} setDate={(e: any) => { setIFechaOut(e) }} />
                    </div>
                    <div className="col-md-2">
                        <label>ID PAA</label>
                        <input type="number" name="idpaa" className="form-control" value={filter.IDAdquisitionItem ?? ''}
                            onChange={(e) => { setFilter({ ...filter, "IDAdquisitionItem": parseInt(e.target.value) }) }} />
                    </div>
                    <div className="col-md-2">
                        <label>Código Contrato</label>
                        <input type="text" name="code" className="form-control" value={filter.InternalCode}
                            onChange={(e) => { setFilter({ ...filter, "InternalCode": e.target.value }) }} />
                    </div>
                    <div className="col-md-2">
                        <label>Descripción</label>
                        <input type="text" name="nece" className="form-control" value={filter.Description}
                            onChange={(e) => { setFilter({ ...filter, "Description": e.target.value }) }} />
                    </div>
                    <div className="col-md-2">
                        <label>Proyecto</label>
                        <input type="text" name="proyecto" className="form-control" value={filter.ProjectName}
                            onChange={(e) => { setFilter({ ...filter, "ProjectName": e.target.value }) }} />
                    </div>
                    <div className="col-md-3">
                        <ContractTypeEditor label={'Tipo Contrato'} idSelector={filter.IDContractType} onChange={(e) => { setFilter({ ...filter, "IDContractType": e }) }} />
                    </div>

                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-6">
                                <BasicButton value="Buscar" useMargin icon="ri-search-line" eventClick={getAdquisitionContractRender} />
                                <BasicButton clase="danger" useMargin icon="ri-delete-bin-2-line" eventClick={() => clearFilter()}>Limpiar Filtros</BasicButton>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <BasicTable
                            head={head}
                            body={lista}
                            headButtons={buttons()}
                            rowSet={setBean}
                            iconButtons={iconButtonsItem}
                            listButtons={listaBotones()}
                            pageTop={paginador.page}
                            next={paginador.next}
                            back={paginador.back}
                            records={paginador}
                        />
                    </div>
                    <div className="col-md-12">
                        <Modal modal={modalModify} updateModal={setModalModify} evenOnClose={getAdquisitionContractRender}>
                            <AdquisitionContracModify contract={bean} />
                        </Modal>
                        <Modal modal={modalResumenContrato.modal} updateModal={modalResumenContrato.setModal} >
                            <ResumeContract nameProp="IDAdquisitionContract" props={bean} />
                        </Modal>
                        <Modal modal={modalSecop.modal} updateModal={modalSecop.setModal} >
                            <InfoSecop contract={bean} />
                        </Modal>

                    </div>
                </div>
            </BasicPage>

            <Modal modal={modalXLS.modal} updateModal={modalXLS.setModal}>
                <ExportXLSL customName={`contratos_${_single.getRandomInt()}`} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaAll} onExport={(name: string) => {
                    single.download("formato xlsx [" + name + "] con " + listaAll.length + " registros");
                    modalXLS.close();
                }} />
            </Modal>

            <Modal modal={modalExpe} updateModal={setModalExpe}>
                <EditorExpedientDocumentFile _ClassForName="com.orange.bean.AdquisitionContract" _IDClass={bean.IDAdquisitionContract} />
                {/* <ContractFiles IDAdquisitionContract={bean.IDAdquisitionContract} IDAdquisitionItem={bean.IDAdquisitionItem} IDHiringModality={bean.IDHiringModality} /> */}
            </Modal>

            {modalRubro.view &&
                <Modal modal={modalRubro} updateModal={setModalRubro} >
                    <AdquisitionItemBudgetID iDBudgetIDType={null} adquisitionItem={bean} />
                </Modal>
            }

            {modalArt.view &&
                <Modal modal={modalArt} updateModal={setModalArt} >
                    <AdquisitionArticle viewHiringProcces={true} adquisitionItem={bean} beanItem={beanItem}></AdquisitionArticle>
                </Modal>
            }

            <Modal modal={modalRP} updateModal={setModalRP}>
                <AdquisitionContractRP adquisitionContract={bean} />
            </Modal>


            {modalPer.view &&
                <Modal modal={modalPer} updateModal={setModalPer}>
                    <OfferEmployee IDAdquisitionItem={bean.IDAdquisitionItem} />
                </Modal>
            }

            {modalRelacion.view &&
                <Modal modal={modalRelacion} updateModal={setModalRelacion}>
                    <ContractArticles idAdquisitionContract={bean.IDAdquisitionContract} idAdquisitionItem={bean.IDAdquisitionItem} updateParent={getAdquisitionContractRender} />
                </Modal>
            }

            {modalConf.view &&
                <Modal modal={modalConf} updateModal={setModalConf} eventModal={elimiarItem}>
                    <div className="row">
                        <div className="col">
                            <strong>Eliminar registro</strong>
                        </div>
                    </div>
                </Modal>
            }

            {modal.view &&
                <Modal modal={modal} updateModal={setModal} eventModal={validateData} >
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-12">
                                    <label className={`${missingFields.includes('IDAdquisitionItem') ? 'has-error' : ''}`}>Necesidad</label>
                                </div>

                                <div className="col-md-12">
                                    <AdquisitionItemSelector
                                        // ConfigProps={{ filterState: 40 }} 
                                        listStates={[40, 12]}
                                        idAdquisitionItem={bean.IDAdquisitionItem} onChage={(item: any) => {
                                            setBean({ ...bean, "IDAdquisitionItem": item.IDAdquisitionItem });
                                            setBeanItem(item)
                                        }} />
                                </div>
                                <div className="col-md-12 mt-2">
                                    {projectValidation.notes.map((note, index) => (
                                        <div
                                            key={`${note.message}-${index}`}
                                            className={`alert alert-${note.severity === "error" ? "danger" : note.severity}`}
                                            role="alert"
                                        >
                                            {note.message}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <hr />
                        </div>

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('AdquisitionContractDate') ? 'has-error' : ''}`}>Fecha Contrato</label>
                            <InputDate label=" " name="AdquisitionContractDate" value={bean.AdquisitionContractDate} setDate={(e) => { setBean({ ...bean, "AdquisitionContractDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('AdquisitionContractDate') ? 'has-error' : ''}`}>Fecha Finalización del Contrato</label>
                            <InputDate label=" " name="EndContractDate" value={bean.EndContractDate} setDate={(e) => { setBean({ ...bean, "EndContractDate": e }) }} />
                        </div>

                        <div className="col-md-6">
                            <label>Código Interno Contrato</label>
                            <input type="text" className="form-control" value={bean.InternalCode} onChange={(e) => { setBean({ ...bean, "InternalCode": e.target.value }) }} />
                        </div>

                        <div className="col-md-6">
                            <label>Radicado Contrato</label>
                            <input type="text" className="form-control" value={bean.Code} onChange={(e) => { setBean({ ...bean, "Code": e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDAccount') ? 'has-error' : ''}`}>Proveedor</label>
                            <AccountEditor idAccount={bean.IDAccount} label=" " onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount, "Nit": e.Nit, "EntityName": e.EntityName }) }} />
                        </div>

                        <div className="col-md-6">
                            <SelectModalityNewSer label={'Modalidad'} idSelector={bean.IDHiringModality} onChange={(e) => { setBean({ ...bean, "IDHiringModality": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <ContractTypeEditor label={'Tipo Contrato'} idSelector={bean.IDContractType} onChange={(e) => { setBean({ ...bean, "IDContractType": e }) }} />
                        </div>
                        <div className="col-md-4">
                            <BasicSwitch label="Es contrato por lotes" estado={bean.isLote} eventChange={(e) => { setBean({ ...bean, "isLote": e }) }} />
                        </div>
                        <div className="col-md-4">
                            <BasicSwitch label="Descontar Aportes a Seguridad Social" estado={bean.DoTaxHoldAsEmployee} eventChange={(e) => { setBean({ ...bean, "DoTaxHoldAsEmployee": e }) }} />
                        </div>
                        <div className="col-md-4">
                            <BasicSwitch label="Calcular Retención en la Fuente como Empleado" estado={bean.DoSocialSecurityDiscounts} eventChange={(e) => { setBean({ ...bean, "DoSocialSecurityDiscounts": e }) }} />
                        </div>
                        <div className="col-md-4">
                            <InputMoney _label="Valor Pago Mensual" _value={bean.PaymentMonthValue} onChange={(e: any) => { setBean({ ...bean, ['PaymentMonthValue']: e }) }} />
                        </div>

                        {/* <PrintJson json={bean}/> */}
                    </div>

                </Modal>

            }
            <Modal modal={modalProject.modal} updateModal={modalProject.setModal} eventModal={actualizarContrato}>
                <ContractProject contract={bean} updateContract={(lista) => { setBean({ ...bean, "ProjectList": lista }) }} />
            </Modal>
            <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                <AutoChart data={listaAll} head={head} useIndexAsXLabel={true}
                    xOptions={['ProjectName', 'Name1', 'ContractTypeName', 'NameModality']}
                    yOptions={['ContractAmount']} />

            </Modal>

            <Modal onSubmitLabel="Solicitar" modal={modalRequest.modal} updateModal={modalRequest.setModal} eventModal={handleModalSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <label>Observaciones</label>
                        <textarea
                            name="obs"
                            rows={5}
                            className={`form-control ${isValid ? "is-invalid" : ""}`}
                            value={obs}
                            onChange={(e) => setObs(e.target.value)}
                        />
                    </div>
                </div>
            </Modal>
        </>
    )
}
